class FerramentaDashboardController extends AbstractController
  @$inject = ['$injector', 'pathService', 'ferramentaDashboardService', 'faturaServicoService']

  constructor: ($injector, pathService, @ferramentaDashboardService, @faturaServicoService) ->
    super($injector)

    @loadingTracker = @promiseTracker()

    @url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/ferramenta-dashboard/'
    @modalFerramentaDashboard = @openPopup("#{@url}modal.html", 'ferramentaDashboardModalController as ctrl', 'lg', 'static')

    @listOfFerramentasDashboard = []
    @listOfFaturaServico = []

    @loadingTracker.addPromise @faturaServicoService.search({select_type: 'simple'}, (data)=>
      @listOfFaturaServico = data
    )

    @loadFerramentasDashboard()

  loadFerramentasDashboard: ->
    @loadingTracker.addPromise @ferramentaDashboardService.getList({select_type: 'complete'}, (data) =>
      data = jQuery.map(data, (ferramenta) =>
        return ferramenta
      ).sort (ferramentaA, ferramentaB) =>
        return parseInt(ferramentaA.indice) > parseInt(ferramentaB.indice)

      @listOfFerramentasDashboard = data
    )

  editar: (ferramenta) ->
    @modalFerramentaDashboard({
      ferramenta: -> ferramenta
      listOfFaturaServico: => @listOfFaturaServico
    }, (result) =>
      if result.success and result.data?.id
        ferramenta = result.data

        index = @listOfFerramentasDashboard.getIndex(ferramenta.id, 'id')
        @listOfFerramentasDashboard[index] = ferramenta
    )

  restaurar: (ferramenta) ->
    Confirm.warning("Atenção",
      "Deseja realmente remover as alterações da ferramenta do dashboard <strong>\"#{ferramenta.title}\"</strong>?<br>Esta ação <strong>não poderá</strong> ser desfeita e todas as informações digitadas manualmente em sua descrição deverão ser inseridas novamente.",
      {
        "Não": null
        "Sim": =>
          @ferramentaDashboardService.update({id: ferramenta.id}, (result) =>
            if result.success and result.data?.id
              ferramenta = result.data

              index = @listOfFerramentasDashboard.getIndex(ferramenta.id, 'id')
              @listOfFerramentasDashboard[index] = ferramenta

              Alert.success("Ferramenta do dashboard <strong>\"#{ferramenta.title}\"</strong> restaurada com sucesso.", "Sucesso!")
          )
      })

angular.module("eficienciaFiscalModule").controller('ferramentaDashboardController', FerramentaDashboardController)


class FerramentaDashboardModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'ferramentaDashboardService', 'ferramenta', 'listOfFaturaServico']

  constructor: ($injector, @modalInstance, @ferramentaDashboardService, ferramenta, @listOfFaturaServico) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @ferramenta = angular.copy ferramenta

  salvar: (form) ->
    if form.$valid and @ferramenta.id
      @ferramenta.faturaServico = if @ferramenta.faturaServico.id then @ferramenta.faturaServico.id else @ferramenta.faturaServico

      @submitTracker.addPromise(
        @ferramentaDashboardService.update(@ferramenta, (result) =>
          if result.success
            Alert.success("Ferramenta do dashboard <strong>\"#{@ferramenta.title}\"</strong> atualizada.", 'Sucesso!')
          else
            Alert.error('Ocorreu um erro ao salvar a ferramenta do dashboard!', 'Erro')

          @modalInstance.close(result)
        )
      )

angular.module("eficienciaFiscalModule").controller('ferramentaDashboardModalController', FerramentaDashboardModalController)